export default __webpack_public_path__ + "static/media/header-title.5d6f37f6.png";